import { Colors } from '../consts/Colors'

export const TextContents = {
    popup: {
        text: "Dans cette < class=\'boldOblique\'>première étape</class>, placez chaque photographie dans le bloc \"LIQUIDITÉS\" ou \"DETTES À ÉCHÉANCE\" pour < class=\'boldOblique\'>reproduire la cessation des paiements.</class>",
    },
    consigne : {
        text : "Placez chaque photographie dans la partie « LIQUIDITÉS » ou « DETTES À ÉCHÉANCE ».",
        config: { size: '22px', fontFamily: 'MassiliaMediumOblique', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    title : {
        text : "TRIBUNAUX DE COMMERCE",
        config: { size: '24px', fontFamily: 'MassiliaBold', align: 'left', color: Colors.Text.Red, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    subtitle : {
        text : "<class=\'regularOblique18\'>Étape 1</class>\nCESSATION DES PAIEMENTS",
        config: { size: '18px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    popupFin : {
        text : "Bravo, vous avez reconstitué les éléments de la cessation des paiements qui se produit lorsque les liquidités de l’entreprise ne couvrent plus ses dettes parvenues à échéance.",
        config: { size: '18px', fontFamily: 'MassiliaRegular', align: 'left', color: Colors.Text.White, backColor: 'transparent', origin: { x: 0, y: 0 }, width: 333 }
    },
    
}

export const CartesInfos = [
    {
        titre: "Administrations\npubliques",
        index: 1,
        image: "adminPublic",
        zoneId: 1,
        correct: "Les sommes dues aux administrations publiques (impôts, taxes) sont bien des dettes. Elles deviennent exigibles une fois leur délai de paiement écoulé (échéance).",
        incorrect : "Les sommes dues aux administrations publiques (impôts, taxes) sont des dettes. Elles deviennent exigibles une fois leur délai de paiement écoulé (échéance).",
        zoneX: 950,
        zoneY: 320
    },
    {
        titre: "La caisse",
        index: 2,
        image: "caisse",
        zoneId: 0,
        correct: "L'argent détenu dans la caisse fait bien partie des liquidités. C'est un actif (ce que l'entreprise possède) immédiatement disponible pour rembourser les dettes.",
        incorrect : "L'argent détenu dans la caisse fait partie des liquidités. C'est un actif (ce que l'entreprise possède) immédiatement disponible pour rembourser les dettes.",
        zoneX: 339,
        zoneY: 605
    },
    {
        titre: "Le compte bancaire",
        index: 3,
        image: "compteBancaire",
        zoneId: 0,
        correct: "L'argent placé sur le compte bancaire de l'entreprise fait bien partie des liquidités. C'est un actif (ce que l'entreprise possède) immédiatement disponible pour rembourser les dettes.",
        incorrect : "L'argent placé sur le compte bancaire de l'entreprise fait partie des liquidités. C'est un actif (ce que l'entreprise possède) immédiatement disponible pour rembourser les dettes.",
        zoneX: 560,
        zoneY: 700
    },
    {
        titre: "Découvert bancaire « non autorisé »",
        index: 4,
        image: "decouvert",
        zoneId: 1,
        correct: "Les sommes dues à un établissement financier suite à un découvert bancaire non autorisé sont bien des dettes. Aucun délai n'est accordé pour leur remboursement qui est immédiatement exigible.",
        incorrect : "Les sommes dues à un établissement financier suite à un découvert bancaire non autorisé sont des dettes. Aucun délai n'est accordé pour son remboursement qui est immédiatement exigible.",
        zoneX: 1182,
        zoneY: 780
    },
    {
        titre: "Fournisseurs",
        index: 5,
        image: "delaiFournisseur",
        zoneId: 1,
        correct: "Les factures reçues des fournisseurs suite à l'achat de biens et/ou de services sont bien des dettes. Elles deviennent exigibles une fois leur délai de paiement éventuel écoulé (échéance).",
        incorrect : "Les factures reçues des fournisseurs suite à l'achat de biens et/ou de services sont des dettes. Elles deviennent exigibles une fois leur délai de paiement éventuel écoulé (échéance).",
        zoneX: 1182,
        zoneY: 320
    },
    {
        titre: "Emprunt bancaire",
        index: 6,
        image: "empruntBancaire",
        zoneId: 1,
        correct: "Les sommes dues à un établissement financier suite à un emprunt bancaire sont bien des dettes payables à échéance régulière. En cas de retards de paiement, elles deviennent exigibles.",
        incorrect : "Les sommes dues à un établissement financier suite à un emprunt bancaire sont des dettes payables à échéance régulière. En cas de retards de paiement, elles deviennent exigibles.",
        zoneX: 950,
        zoneY: 780
    },
    {
        titre: "Organismes sociaux",
        index: 7,
        image: "organismeSociaux",
        zoneId: 1,
        correct: "Les sommes dues aux organismes sociaux (cotisations sociales) sont bien des dettes. Elles ne bénéficient généralement d'aucun délai de paiement et sont donc immédiatement exigibles.",
        incorrect : "Les sommes dues aux organismes sociaux (cotisations sociales) sont des dettes. Elles ne bénéficient généralement d'aucun délai de paiement et sont donc immédiatement exigibles.",
        zoneX: 1182,
        zoneY: 555
    },
    {
        titre: "Salariés",
        index: 8,
        image: "salaries",
        zoneId: 1,
        correct: "Les sommes dues aux salariés sont bien des dettes. Elles ne bénéficient d'aucun délai de paiement et sont donc immédiatement exigibles.",
        incorrect : "Les sommes dues aux salariés sont des dettes. Elles ne bénéficient d'aucun délai de paiement et sont donc immédiatement exigibles.",
        zoneX: 950,
        zoneY: 555
    },
]

export const ZonesInfos = [
    {
        index: 1,
        zoneX: 449,
        zoneId: 0,
        areaColor: Colors.Elmt.LightRed,
        areaContent:"LIQUIDITÉS\n<class=\'medium22\'>(Actifs disponibles)</class>"
    },
    {
        index: 2,
        zoneX: 1063,
        zoneId: 1,
        areaColor: Colors.Elmt.DarkBlue,
        areaContent: "DETTES À ÉCHÉANCE\n<class=\'medium22\'>(Exigibles)</class>"
    },
]